import React, { Component, createRef } from "react";
import { ReactComponent as ScreenIcon1 } from "assets/icons/screens-icon_1.svg";
import { ReactComponent as ScreenIcon2A } from "assets/icons/screens-icon_2a.svg";
import { ReactComponent as ScreenIcon2B } from "assets/icons/screens-icon_2b.svg";
import { ReactComponent as ScreenIcon3A } from "assets/icons/screens-icon_3a.svg";
import { ReactComponent as ScreenIcon3B } from "assets/icons/screens-icon_3b.svg";
import { ReactComponent as ScreenIcon3C } from "assets/icons/screens-icon_3c.svg";
import { ReactComponent as ScreenIcon3D } from "assets/icons/screens-icon_3d.svg";
import { ReactComponent as ScreenIcon4 } from "assets/icons/screens-icon_4.svg";

import { withNamespaces } from "react-i18next";

import "./styles.scss";

export const GamesLayoutType = {
  LAYOUT_1: "layout_1",
  LAYOUT_2A: "layout_2a",
  LAYOUT_2B: "layout_2b",
  LAYOUT_3A: "layout_3a",
  LAYOUT_3B: "layout_3b",
  LAYOUT_3C: "layout_3c",
  LAYOUT_3D: "layout_3d",
  LAYOUT_4: "layout_4",
};

class FloatingGamesLayout extends Component {
  constructor(props) {
    super(props);
    this.activeRef = createRef();
    this.getSelectedIcon = this._getSelectedIcon.bind(this);
    this.onActivate = this._onActivate.bind(this);
    this.onTouchMove = this._onTouchMove.bind(this);
    this.state = {
      collapse: true,
      layout: "top left",
    };
  }

  _getSelectedIcon(layout) {
    switch (layout) {
      case GamesLayoutType.LAYOUT_2A:
        return <ScreenIcon2A />;
      case GamesLayoutType.LAYOUT_2B:
        return <ScreenIcon2B />;
      case GamesLayoutType.LAYOUT_3A:
        return <ScreenIcon3A />;
      case GamesLayoutType.LAYOUT_3B:
        return <ScreenIcon3B />;
      case GamesLayoutType.LAYOUT_3C:
        return <ScreenIcon3C />;
      case GamesLayoutType.LAYOUT_3D:
        return <ScreenIcon3D />;
      case GamesLayoutType.LAYOUT_4:
        return <ScreenIcon4 />;
      default:
        return <ScreenIcon1 />;
    }
  }

  setGameLayout(layout) {
    let count;
    switch (layout) {
      case GamesLayoutType.LAYOUT_2A:
      case GamesLayoutType.LAYOUT_2B:
        count = 2;
        break;
      case GamesLayoutType.LAYOUT_3A:
      case GamesLayoutType.LAYOUT_3B:
      case GamesLayoutType.LAYOUT_3C:
      case GamesLayoutType.LAYOUT_3D:
        count = 3;
        break;
      case GamesLayoutType.LAYOUT_4:
        count = 4;
        break;
      default:
        count = 1;
        break;
    }

    count > 1
      ? this.props.broadcastGameMode("MULTI")
      : this.props.broadcastGameMode("SINGLE");

    this.props.setMultiGame(count, layout);
  }

  _onActivate(e) {
    e.stopPropagation();
    e.preventDefault();
    const elemParent = e.currentTarget.parentElement;
    if (elemParent.classList.contains("active")) {
      elemParent.classList.remove("active");
    } else {
      elemParent.classList.add("active");
    }
  }

  _onTouchMove(e) {
    //if (!this.state.collapse) return;

    e.preventDefault();
    const elem = e.currentTarget;
    const parent = elem.parentElement;
    const boundery = 50;

    const x = e.changedTouches[0].pageX;
    const y = e.changedTouches[0].pageY;

    // Get parent size
    const parentWidth = parent.offsetWidth;
    const parentHeight = parent.offsetHeight;

    let newX = x;
    let newY = y;

    if (x >= parentWidth - boundery) newX = parentWidth - boundery;
    if (x <= boundery) newX = boundery;
    if (y >= parentHeight - boundery) newY = parentHeight - boundery;
    if (y <= boundery) newY = boundery;

    let layout = parentHeight / 2 <= y ? "bottom" : "top";
    layout = `${layout} ${parentWidth / 2 <= x ? "right" : "left"}`;

    this.setState({
      layout,
      collapse: true,
    });

    elem.style.left = `${(newX / parentWidth) * 100}%`;
    elem.style.top = `${(newY / parentHeight) * 100}%`;
  }

  render() {
    let { t } = this.props;
    return (
      <span className="floating-games-layout">
        <div
          className={`layout-selection-background ${
            this.state.collapse ? "d-none" : ""
          }`}
          onClick={() => {
            this.setState({
              collapse: true,
            });
          }}
          draggable={false}
        />
        <div
          ref={this.activeRef}
          className={`active-layout ${this.state.collapse ? "" : "active"}`}
          onTouchMove={this.onTouchMove}
          onClick={() => {
            this.setState({
              collapse: !this.state.collapse,
            });
          }}
        >
          {this.getSelectedIcon(this.props.multiGameLayout)}{" "}
          <span className="layout-selection-holder">
            <ul
              className={`layout-selection ${
                this.state.collapse ? "collapse-panel" : ""
              } ${this.state.layout}`}
            >
              { this.state.layout.includes("bottom") && 
                <li className="label">
                  <span>{t("singlePlay")}</span>
                </li> 
              }               
              <li
                onClick={() => {
                  this.setGameLayout(GamesLayoutType.LAYOUT_1);
                }}
              >
                <ScreenIcon1 />
              </li>
              { this.state.layout.includes("top") && 
                <li className="label">
                  <span>{t("singlePlay")}</span>
                </li> 
              }             
              {this.props.layout === "landscape" && (
                <li
                  onClick={() => {
                    this.setGameLayout(GamesLayoutType.LAYOUT_2A);
                  }}
                >
                  <ScreenIcon2A />
                </li>
              )}
              { this.state.layout.includes("bottom") &&
                <li className="label">
                  <span>{t("multiPlay")}</span>
                </li> 
              }
              {this.props.layout === "portrait" && (
                <li
                  onClick={() => {
                    this.setGameLayout(GamesLayoutType.LAYOUT_2B);
                  }}
                >
                  <ScreenIcon2B />
                </li>
              )}
              { this.state.layout.includes("top") && 
                <li className="label">
                  <span>{t("multiPlay")}</span>
                </li> 
              }         
              {this.props.deviceSize !== "mobile" && (
                <>
                  <li
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_3A);
                    }}
                  >
                    <ScreenIcon3A />
                  </li>
                  <li
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_3B);
                    }}
                  >
                    <ScreenIcon3B />
                  </li>
                  <li
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_3C);
                    }}
                  >
                    <ScreenIcon3C />
                  </li>
                  <li
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_3D);
                    }}
                  >
                    <ScreenIcon3D />
                  </li>
                  <li
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_4);
                    }}
                  >
                    <ScreenIcon4 />
                  </li>
                </>
              )}

              <div className="d-none">
                <div className="text-center">
                  <span
                    className={`icon ${
                      this.props.multiGameLayout === GamesLayoutType.LAYOUT_1
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_1);
                    }}
                  >
                    <ScreenIcon1 />
                  </span>
                </div>
                <div className="text-center">{t("singlePlay")}</div>
                <div className="text-center">
                  <span
                    className={`icon ${
                      this.props.multiGameLayout === GamesLayoutType.LAYOUT_2A
                        ? "selected"
                        : ""
                    } ${this.props.layout === "landscape" ? "" : "d-none"}`}
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_2A);
                    }}
                  >
                    <ScreenIcon2A />
                  </span>
                  <span
                    className={`icon ${
                      this.props.multiGameLayout === GamesLayoutType.LAYOUT_2B
                        ? "selected"
                        : ""
                    } ${this.props.layout === "portrait" ? "" : "d-none"}`}
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_2B);
                    }}
                  >
                    <ScreenIcon2B />
                  </span>
                </div>
                <div className="text-center">{t("multiPlay")}</div>

                <span
                  className={`icon ${
                    this.props.multiGameLayout === GamesLayoutType.LAYOUT_3A
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    this.setGameLayout(GamesLayoutType.LAYOUT_3A);
                  }}
                >
                  <ScreenIcon3A />
                </span>
                <span
                  className={`icon ${
                    this.props.multiGameLayout === GamesLayoutType.LAYOUT_3B
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    this.setGameLayout(GamesLayoutType.LAYOUT_3B);
                  }}
                >
                  <ScreenIcon3B />
                </span>
                <span
                  className={`icon ${
                    this.props.multiGameLayout === GamesLayoutType.LAYOUT_3C
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    this.setGameLayout(GamesLayoutType.LAYOUT_3C);
                  }}
                >
                  <ScreenIcon3C />
                </span>
                <span
                  className={`icon ${
                    this.props.multiGameLayout === GamesLayoutType.LAYOUT_3D
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    this.setGameLayout(GamesLayoutType.LAYOUT_3D);
                  }}
                >
                  <ScreenIcon3D />
                </span>

                <div
                  className={`${
                    this.props.deviceSize === "mobile" ? "d-none" : ""
                  }`}
                >
                  <span
                    className={`icon ${
                      this.props.multiGameLayout === GamesLayoutType.LAYOUT_4
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => {
                      this.setGameLayout(GamesLayoutType.LAYOUT_4);
                    }}
                  >
                    <ScreenIcon4 />
                  </span>
                </div>
              </div>
            </ul>
          </span>
        </div>
        {/*
        <div className="fab fabHorizontal d-none">
          <div className="fabNav fabNav--left">
            <a href="" className="fabItem ic-facebook">
              <span className="fabTooltip">Facebook</span>
              <i className="fa-brands fa-facebook-f" />
            </a>
            <a href="" className="fabItem ic-ig">
              <span className="fabTooltip">Instagram</span>
              <i className="fa-brands fa-instagram" />
            </a>
            <a href="" className="fabItem ic-tw">
              <span className="fabTooltip">Twitter</span>
              <i className="fa-brands fa-x-twitter" />
            </a>
          </div>
          <div className="fabTrigger" onClick={this.onActivate}>
            <a href="">
              <span className="icon" />
            </a>
          </div>
          <div className="fabNav fabNav--right">
            <a href="" className="fabItem ic-facebook">
              <span className="fabTooltip">Hotline</span>
              <i className="fa-solid fa-phone" />
            </a>
            <a href="" className="fabItem ic-ig">
              <span className="fabTooltip">Livechat</span>
              <i className="fa-regular fa-comment-dots" />
            </a>
            <a href="" className="fabItem ic-tw">
              <span className="fabTooltip">Map</span>
              <i className="fa-solid fa-location-dot" />
            </a>
          </div>
        </div>
        <div className="fab fabVertical d-none">
          <div className="fabNav fabNav--left">
            <a href="" className="fabItem ic-facebook">
              <span className="fabTooltip">Facebook</span>
              <i className="fa-brands fa-facebook-f" />
            </a>
            <a href="" className="fabItem ic-ig">
              <span className="fabTooltip">Instagram</span>
              <i className="fa-brands fa-instagram" />
            </a>
            <a href="" className="fabItem ic-tw">
              <span className="fabTooltip">Twitter</span>
              <i className="fa-brands fa-x-twitter" />
            </a>
          </div>
          <div className="fabTrigger" onClick={this.onActivate}>
            <a href="">
              <span className="icon" />
            </a>
          </div>
          <div className="fabNav fabNav--right">
            <a href="" className="fabItem ic-facebook">
              <span className="fabTooltip">Hotline</span>
              <i className="fa-solid fa-phone" />
            </a>
            <a href="" className="fabItem ic-ig">
              <span className="fabTooltip">Livechat</span>
              <i className="fa-regular fa-comment-dots" />
            </a>
            <a href="" className="fabItem ic-tw">
              <span className="fabTooltip">Map</span>
              <i className="fa-solid fa-location-dot" />
            </a>
          </div>
        </div>*/}
      </span>
    );
  }
}

export default withNamespaces("translation")(FloatingGamesLayout);
